import { render, staticRenderFns } from "./PlacementGoalsInput.vue?vue&type=template&id=09ee8e9b"
import script from "./PlacementGoalsInput.vue?vue&type=script&lang=js"
export * from "./PlacementGoalsInput.vue?vue&type=script&lang=js"
import style0 from "./PlacementGoalsInput.vue?vue&type=style&index=0&id=09ee8e9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports